import type {AuthService, CloudFunctionsService} from '../types/services'
import type {AuthUser, UserProfile} from '../types/domain'
export const GOOGLE_SIGN_IN = 'google'

export const googleLogin = (authService: AuthService, service: CloudFunctionsService) => authService.signIn(GOOGLE_SIGN_IN, service)

export const DEFAULT_STATE = {
  user: null as AuthUser | null,
  userProfile: null as UserProfile | null,
  authenticating: false,
  creatingProfile: false,
  listeningToAuth: false,
  listeningToUserProfile: false,
  isLoading: true,
  hasAgreedToTerms: false,
}

export const AUTHENTICATION_START = '@auth/AUTHENTICATION_START'
export const AUTHENTICATION_COMPLETE = '@auth/AUTHENTICATION_COMPLETE'
export const CREATING_USER_PROFILE = '@auth/CREATING_USER_PROFILE'
export const USER_PROFILE_CREATED = '@auth/USER_PROFILE_CREATED'
export const USER_PROFILE_UPDATED = '@auth/USER_PROFILE_UPDATED'
export const START_LISTENING_TO_AUTH = '@auth/START_LISTENING_TO_AUTH'
export const START_LISTENING_TO_USER_PROFILE = '@auth/START_LISTENING_TO_USER_PROFILE'
export const NO_USER_PROFILE_EXISTS = '@auth/NO_USER_PROFILE_EXISTS'

type AuthAction =
  | {type: typeof AUTHENTICATION_COMPLETE; payload: AuthUser | null}
  | {type: typeof USER_PROFILE_UPDATED | typeof USER_PROFILE_CREATED; payload: UserProfile | null}
  | {type: typeof AUTHENTICATION_START | typeof CREATING_USER_PROFILE | typeof START_LISTENING_TO_AUTH | typeof START_LISTENING_TO_USER_PROFILE | typeof NO_USER_PROFILE_EXISTS}

export default (state = DEFAULT_STATE, action: AuthAction) => {
  const {type} = action
  switch (type) {
    case AUTHENTICATION_START:
      return { ...state, authenticating: true, creatingProfile: true, isLoading: true }
    case START_LISTENING_TO_AUTH:
      return {
        ...state,
        listeningToAuth: true,
      }
    case START_LISTENING_TO_USER_PROFILE:
      return {
        ...state,
        listeningToUserProfile: true,
        isLoading: true,
      }
    case CREATING_USER_PROFILE:
      return { ...state, creatingProfile: true, isLoading: true }
    case USER_PROFILE_UPDATED:
      return {
        ...state,
        userProfile: action.payload,
        creatingProfile: false,
        hasAgreedToTerms: !!action.payload,
        isLoading: !!action.payload,
      }
    case USER_PROFILE_CREATED:
      return {
        ...state,
        userProfile: action.payload,
        creatingProfile: false,
        hasAgreedToTerms: true,
        isLoading: false,
      }
    case AUTHENTICATION_COMPLETE:
      return {
        ...state,
        authenticating: false,
        user: action.payload,
        isLoading: state.creatingProfile,
      }
    case NO_USER_PROFILE_EXISTS:
      return {
        ...state,
        hasAgreedToTerms: false,
        isLoading: false,
      }
    default:
      return state
  }
}
